"use client";
import {
  CheckboxCheckedSvg,
  CheckboxUncheckSvg,
  EyeOffSvg,
  EyeOnSvg,
} from "@/public/svg";
import React, { useEffect, useState } from "react";
import Container from "../_component/Container";
import { useRouter } from "next/navigation";
import { signIn } from "next-auth/react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Input from "@/components/atom/Input";
import Button from "@/components/atom/Button";
import fetchAPI from "@/functions/fetchAPI";
import useHeader from "@/functions/useHeader";
import Loading from "@/components/atom/Loading";
import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export default function SignIn() {
  const { session, status } = useHeader();
  const router = useRouter();
  const [hidePw, setHidePw] = useState(true);
  const [checkedIngatkan, setCheckedIngatkan] = useState(false);
  const [loading, setLoading] = useState({ submit: false });
  const [myValue, setMyValue] = useState({
    emailOrPhone: "",
    password: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    emailOrPhone: "",
    password: "",
  });

  function handleChange(state, setState, value) {
    if (
      state === "emailOrPhone" &&
      (value.startsWith("0") || value.startsWith("62"))
    ) {
      value = "+62" + value.slice(2);
    }
    return setState((old) => ({ ...old, [state]: value }));
  }

  function handleError(error, setState, allState) {
    function checkErrorMsg(msg, arr) {
      for (const item of arr) {
        const testMsg = new RegExp(`\\b${item}\\b`, "i");
        if (testMsg.test(msg)) {
          return item;
        }
      }
      return null;
    }

    const key =
      checkErrorMsg(error?.message, allState) !== "password"
        ? "emailOrPhone"
        : "password";

    setState({
      [key]: error?.message,
    });
  }

  function validateForm() {
    const phoneNumberRegex = /^(08|\+628)\d{8,}$/;
    const statusPhone = phoneNumberRegex.test(myValue?.emailOrPhone);

    let errors = {};

    if (!myValue.emailOrPhone) {
      errors.emailOrPhone = "Email or Phone is required";
    } else if (!isValidEmail(myValue.emailOrPhone) && !statusPhone) {
      errors.emailOrPhone = "Invalid email";
    }

    if (!myValue.password) {
      errors.password = "Password is required";
    } else if (myValue?.password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  }

  async function login(e) {
    e.preventDefault();
    setLoading((old) => ({ ...old, submit: true }));
    try {
      if (!validateForm()) return;

      let payload = {
        password: myValue?.password,
      };

      const phoneNumberRegex = /^(08|\+628)\d{8,}$/;
      const statusPhone = phoneNumberRegex.test(myValue?.emailOrPhone);

      payload = statusPhone
        ? {
            ...payload,
            telephone: myValue?.emailOrPhone.replace("+", ""),
            email: "",
          }
        : {
            ...payload,
            email: myValue?.emailOrPhone,
            telephone: "",
          };

      setLoading((old) => ({ ...old, load: true }));
      let uri = `auth/signInMitra`;
      let body = {
        ...payload,
      };
      const res1 = await fetchAPI({
        uri,
        method: "POST",
        body,
      });

      if (res1?.error) {
        setLoading((old) => ({ ...old, load: false }));
        return handleError(res1.error, setValidationErrors, [
          "email",
          "password",
          "telephone",
        ]);
      }

      const fpPromise = await (await FingerprintJS.load()).get();
      const res = await signIn("credentials", {
        ...payload,
        datas: JSON.stringify(res1),
        fingerPrintID: fpPromise?.visitorId,
        redirect: false,
        callbackUrl: "/",
      });

      if (res?.error == "CredentialsSignin") {
        setLoading((old) => ({ ...old, load: false }));
        return setValidationErrors({
          emailOrPhone:
            "Invalid credentials. Please check your username and password.",
        });
      }

      if (res.url) {
        if (checkedIngatkan) {
          localStorage.setItem("ingatkanSayaMitra", JSON.stringify(myValue));
        } else localStorage.removeItem("ingatkanSayaMitra");

        router.push(res.url);
        return router.refresh();
      }
    } catch (error) {
      setLoading((old) => ({ ...old, load: false }));
      console.log(error?.message);
    } finally {
      setLoading((old) => ({ ...old, submit: false }));
    }
  }

  useEffect(() => {
    if (loading?.load || loading?.submit) return;
    if (session?.user?.token) {
      router.push("/");
      return router.refresh();
    }
  }, [session?.user?.token, loading]);

  useEffect(() => {
    let objIngatkanSaya = localStorage.getItem("ingatkanSayaMitra");
    objIngatkanSaya = JSON.parse(objIngatkanSaya || "{}");
    if (!objIngatkanSaya || isEmpty(objIngatkanSaya)) return;
    setMyValue(objIngatkanSaya);
    setCheckedIngatkan(true);
  }, []);

  return loading?.load ? (
    <Loading />
  ) : (
    <Container>
      <div className='flex flex-col gap-4 lg:max-w-lg'>
        <p className='h4-semiBold text-primaryGON-400'>Masuk Akun</p>
        <p className='p1-regular text-greyscaleGON-500'>
          Pastikan Anda menggunakan email dan password yang benar untuk masuk ke{" "}
          {process.env.COMPANY_NAME}.
        </p>
        <div className='flex flex-col gap-10'>
          <div className='flex flex-col gap-4'>
            <Input
              onSubmit={login}
              label={"Email"}
              placeholder='Masukkan Email'
              onChange={(value) =>
                handleChange("emailOrPhone", setMyValue, value)
              }
              value={myValue?.emailOrPhone}
              error={!validationErrors?.emailOrPhone ? false : true}
              caption={validationErrors?.emailOrPhone}
              type="email"
            />
            <Input
              onSubmit={login}
              label={"Kata Sandi"}
              placeholder='Masukkan kata sandi'
              type={hidePw ? "password" : "text"}
              icon={{
                right: (props) =>
                  hidePw ? <EyeOffSvg {...props} /> : <EyeOnSvg {...props} />,
                onClickRight: () => setHidePw(!hidePw),
              }}
              footer={{
                title: "Lupa Kata Sandi?",
                onClick: () => router.push("/forget-password"),
              }}
              onChange={(value) => handleChange("password", setMyValue, value)}
              value={myValue?.password}
              error={!validationErrors?.password ? false : true}
              caption={validationErrors?.password}
            />
          </div>
          <div className='flex flex-col gap-4'>
            <div
              className='flex gap-2 items-center cursor-pointer w-fit'
              onClick={() => setCheckedIngatkan(!checkedIngatkan)}>
              {checkedIngatkan ? (
                <CheckboxCheckedSvg className='h-4 w-4 xs:h-6 xs:w-6 text-primaryGON-400' />
              ) : (
                <CheckboxUncheckSvg className='h-4 w-4 xs:h-6 xs:w-6 text-greyscaleGON-500' />
              )}
              <p className='p1-regular text-greyscaleGON-600'>Ingat saya</p>
            </div>
            <Button
              label='Masuk'
              size='large'
              onClick={(e) => login(e)}
              disable={
                !myValue?.emailOrPhone ||
                !myValue?.password ||
                loading?.submit ||
                loading?.load ||
                status == "loading"
              }
              loading={loading?.submit || loading?.load}
            />
            {/* <Button
              label='Buat Akun'
              variants='outline'
              size='large'
              onClick={(e) => {
                router.push("/signup");
              }}
              loading={loading?.submit}
            /> */}
          </div>
        </div>
      </div>
    </Container>
  );
}
